export const hazardous = [
  { name: "UL Class 1 / Division 1 ::  ATEX Zone 0" },
  { name: "UL Class 1 / Division 1 :: ATEX Zone 1 " },
  { name: "UL Class 1 / Division 2 :: ATEX Zone 2" },
  { name: "Non-Hazardous Area" }
];
